import * as S from './styles/JoinTermsStyle';
import img from '@assets/image';

type Props = {
  onChangeCheckbox: (checked: boolean) => void;
  onClickPrev: () => void;
  onClickNext: () => void;
};

const JoinTerms = ({ onChangeCheckbox, onClickPrev, onClickNext }: Props) => {
  return (
    <S.JoinTerms>
      <S.Header>
        <img src={img.mcallLogo} alt='MCALL로고' />
      </S.Header>
      <S.ProcessBox>
        <h2>회원가입</h2>
        <S.Process>
          <p className='active'>약관동의</p>
          <p>업체정보 입력</p>
          <p>가입완료</p>
          <span className='nav-indicator'></span>
        </S.Process>
      </S.ProcessBox>
      <S.Contents>
        <S.Terms>
          <S.Title>
            <h3>사이트 이용 약관&nbsp;(필수)</h3>
            <label>
              <input
                type='checkbox'
                onChange={(e) => {
                  onChangeCheckbox(e.currentTarget.checked);
                }}
              />
              동의합니다
            </label>
          </S.Title>
          <S.Content>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </S.Content>
        </S.Terms>
        <S.Terms>
          <S.Title>
            <h3>개인정보 수집 및 이용&nbsp;(필수)</h3>
            <label>
              <input
                type='checkbox'
                onChange={(e) => {
                  onChangeCheckbox(e.currentTarget.checked);
                }}
              />
              동의합니다
            </label>
          </S.Title>
          <S.Content>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </S.Content>
        </S.Terms>
        <S.Btns>
          <S.Btn type='button' onClick={onClickPrev}>
            이전
          </S.Btn>
          <S.Btn type='button' onClick={onClickNext} className='active'>
            다음
          </S.Btn>
        </S.Btns>
      </S.Contents>
    </S.JoinTerms>
  );
};

export default JoinTerms;
